import { Component, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import {ValidationService} from '../service/validation-service';

@Component({
  selector: 'control-message',
  template: `<div *ngIf="errorMessage !== null"></div>`
})
export class ControlMessageComponent {
  // @ts-ignore
  errorMessage: string;
  @Input() control: FormControl;
  constructor() { }
// even if it complains of unused property leave it there validation service uses it.
  // @ts-ignore
  get errorMessage() {

    for (const propertyName in this.control.errors) {
      if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
        return ValidationService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName]);
      }
    }

    return null;
  }
}
